(() => {
  const initToolbar = (toolbar) => {
    if (!toolbar || toolbar.dataset.toolbarInitialized === 'true') return;
    toolbar.dataset.toolbarInitialized = 'true';

    const sortTrigger = toolbar.querySelector('[data-toolbar-sort-trigger]');
    const sortOptions = toolbar.querySelector('[data-toolbar-sort-options]');
    const sortBackdrop = toolbar.querySelector('[data-toolbar-sort-backdrop]');
    const sortClose = toolbar.querySelector('[data-toolbar-sort-close]');
    const filterTrigger = toolbar.querySelector('[data-toolbar-filter-trigger]');
    const facets = toolbar.querySelector('[data-toolbar-facets]');
    const filterDisclosure = facets?.querySelector('.mobile-facets__disclosure');
    const drawer = facets?.querySelector('#FacetFiltersFormMobile');
    const drawerClose = drawer?.querySelector('[data-close-drawer]');
    const drawerHeading = toolbar.dataset.toolbarDrawerHeading;
    const isMobile = () => window.matchMedia('(max-width: 749px)').matches;
    let sortRestoreFocus = null;
    let filterRestoreFocus = null;
    let filterCloseTimer = null;
    let filterOpen = false;
    let filterClosing = false;
    if (drawerHeading) facets?.querySelectorAll('.mobile-facets__heading').forEach((heading) => { heading.textContent = drawerHeading; });
    if (drawer) drawer.setAttribute('aria-hidden', 'true');

    const hasOtherScrollLock = () => Boolean(
      document.querySelector('cart-drawer[open], side-drawer.open, modal-dialog[open]') ||
      document.querySelector('.menu-opening:not(.collection-toolbar__filter-disclosure)')
    );
    const syncScrollLock = () => {
      if (filterOpen) {
        document.body.classList.add('collection-toolbar-filter-open');
        document.documentElement.setAttribute('scroll-lock', '');
      } else {
        document.body.classList.remove('collection-toolbar-filter-open');
        if (!hasOtherScrollLock()) document.documentElement.removeAttribute('scroll-lock');
      }
    };
    const getFocusable = () => drawer?.querySelectorAll(
      'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    ) || [];
    const syncFilterState = () => {
      filterTrigger?.setAttribute('aria-expanded', String(filterOpen));
      drawer?.setAttribute('aria-hidden', String(!filterOpen));
      toolbar.classList.toggle('collection-toolbar--filter-open', filterOpen);
      toolbar.classList.toggle('collection-toolbar--filter-closing', filterClosing);
      filterDisclosure?.classList.toggle('collection-toolbar__filter-disclosure', filterOpen);
      if (filterDisclosure) filterDisclosure.setAttribute('aria-hidden', String(!filterOpen));
    };
    const closeFilter = (restoreFocus = true) => {
      if (!filterOpen || !drawer || !filterDisclosure) return;
      filterOpen = false;
      filterClosing = true;
      window.clearTimeout(filterCloseTimer);
      syncFilterState();
      syncScrollLock();
      filterCloseTimer = window.setTimeout(() => {
        if (!filterOpen) {
          filterDisclosure.removeAttribute('open');
          filterClosing = false;
          syncFilterState();
        }
      }, 350);
      const focusTarget = filterRestoreFocus;
      filterRestoreFocus = null;
      if (restoreFocus && focusTarget?.isConnected) focusTarget.focus({ preventScroll: true });
    };
    const openFilter = () => {
      if (!drawer || !filterDisclosure || filterOpen) return;
      filterRestoreFocus = document.activeElement;
      window.clearTimeout(filterCloseTimer);
      filterClosing = false;
      filterDisclosure.setAttribute('open', '');
      filterOpen = true;
      syncFilterState();
      syncScrollLock();
      const focusTarget = drawerClose || getFocusable()[0];
      focusTarget?.focus({ preventScroll: true });
    };

    const updateStickyOffset = () => {
      const header = document.querySelector('#header-component');
      if (!header || !toolbar.classList.contains('collection-toolbar--sticky')) return;
      const rect = header.getBoundingClientRect();
      toolbar.style.setProperty('--collection-toolbar-sticky-top', `${Math.max(0, Math.min(window.innerHeight, rect.bottom))}px`);
    };
    let stickyFrame;
    const scheduleStickyOffset = () => {
      if (stickyFrame) return;
      stickyFrame = requestAnimationFrame(() => { stickyFrame = undefined; updateStickyOffset(); });
    };
    updateStickyOffset();
    window.addEventListener('scroll', scheduleStickyOffset, { passive: true });
    window.addEventListener('resize', scheduleStickyOffset, { passive: true });
    const header = document.querySelector('#header-component');
    if (header && typeof ResizeObserver !== 'undefined') new ResizeObserver(scheduleStickyOffset).observe(header);

    const closeSort = (restoreFocus = true) => {
      if (!sortOptions || !sortTrigger) return;
      if (sortOptions.hidden) return;
      sortOptions.hidden = true;
      sortOptions.classList.remove('is-open');
      sortBackdrop?.setAttribute('hidden', '');
      sortTrigger.setAttribute('aria-expanded', 'false');
      if (isMobile()) {
        if (typeof removeTrapFocus === 'function') removeTrapFocus(restoreFocus ? sortRestoreFocus || sortTrigger : undefined);
        if (!filterDisclosure?.hasAttribute('open')) {
          document.body.classList.remove('overflow-hidden-mobile');
          document.documentElement.removeAttribute('scroll-lock');
        }
      }
      sortRestoreFocus = null;
    };
    const openSort = () => {
      if (!sortOptions || !sortTrigger) return;
      sortRestoreFocus = document.activeElement;
      sortOptions.hidden = false;
      sortOptions.classList.toggle('is-open', isMobile());
      if (isMobile()) {
        sortBackdrop?.removeAttribute('hidden');
        document.body.classList.add('overflow-hidden-mobile');
        document.documentElement.setAttribute('scroll-lock', '');
        if (typeof trapFocus === 'function') trapFocus(sortOptions, sortClose);
        sortClose?.focus({ preventScroll: true });
      } else {
        sortOptions.querySelector('input:checked')?.focus();
      }
      sortTrigger.setAttribute('aria-expanded', 'true');
    };
    syncFilterState();

    sortTrigger?.addEventListener('click', () => {
      if (!sortOptions) return;
      const open = !sortOptions.hidden;
      if (open) closeSort(); else openSort();
    });
    sortClose?.addEventListener('click', () => closeSort());
    sortBackdrop?.addEventListener('click', () => closeSort());
    sortOptions?.addEventListener('change', (event) => {
      const input = event.target.closest('input[name="sort_by"]');
      if (!input) return;
      sortOptions.querySelectorAll('.collection-toolbar__sort-option').forEach((option) => option.classList.toggle('is-selected', option.contains(input)));
      closeSort();
    });

    filterTrigger?.addEventListener('click', () => {
      closeSort(false);
      if (filterOpen) closeFilter(); else openFilter();
    });
    filterDisclosure?.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      const summary = target?.closest('summary');
      if (summary?.parentElement !== filterDisclosure) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (filterOpen) closeFilter(); else openFilter();
    }, true);
    drawer?.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;
      if (target.closest('[data-close-drawer]') || target.closest('[data-drawer-overlay]')) {
        event.preventDefault();
        event.stopImmediatePropagation();
        closeFilter();
        return;
      }
    }, true);
    document.addEventListener('keydown', (event) => {
      if (!filterOpen) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeFilter();
        return;
      }
      if (event.key !== 'Tab') return;
      const focusable = Array.from(getFocusable());
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
    document.addEventListener('focusin', (event) => {
      if (!filterOpen || !drawer || drawer.contains(event.target)) return;
      (drawerClose || getFocusable()[0])?.focus({ preventScroll: true });
    });
    document.addEventListener('click', (event) => { if (!toolbar.contains(event.target)) closeSort(); });
    document.addEventListener('keyup', (event) => {
      if (event.key !== 'Escape') return;
      closeSort();
    });
    window.addEventListener('popstate', () => {
      const value = new URLSearchParams(window.location.search).get('sort_by');
      const input = value && toolbar.querySelector(`input[name="sort_by"][value="${CSS.escape(value)}"]`);
      if (input) {
        toolbar.querySelectorAll('.collection-toolbar__sort-option').forEach((option) => option.classList.toggle('is-selected', option.contains(input)));
        input.checked = true;
      }
    });

    const filterCount = toolbar.querySelector('[data-toolbar-filter-count]');
    const productGridContainer = document.getElementById('ProductGridContainer');
    if (productGridContainer && filterCount && typeof MutationObserver !== 'undefined') {
      new MutationObserver(() => {
        const productCount = productGridContainer.querySelector('#ProductCount');
        const match = productCount?.textContent.match(/[\d,.]+/);
        if (match) filterCount.textContent = match[0];
      }).observe(productGridContainer, { childList: true, subtree: true, characterData: true });
    }
  };
  const boot = () => document.querySelectorAll('[data-collection-toolbar]').forEach(initToolbar);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true }); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
